export default "__VITE_ASSET__D$LwLc2Y__"